export default __webpack_public_path__ + "static/media/TrashGray.a92ae135.svg";